var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightbid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 8.41841V2.12292C1 1.50259 1.50259 1 2.12292 1H34.0947C34.7151 1 35.2177 1.50259 35.2177 2.12292V29.8771C35.2177 30.4974 34.7151 31 34.0947 31H28.6991M1 10.8281V29.8771C1 30.4974 1.50259 31 2.12292 31H26.2894M27.5238 5.3822H1.18658M35.0311 5.3822H29.9335",
    stroke: "url(#paint0_linear_173_3195)",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49059 13.0669L9.41463 8.01501C9.42608 7.98494 9.4464 7.95905 9.4729 7.94078C9.49939 7.92251 9.53081 7.91272 9.563 7.9127C9.62909 7.9127 9.68823 7.9536 9.71157 8.01543L11.6179 13.0668M8.10279 11.7833H11.0156M25.0891 10.2881H26.5872C27.2426 10.2881 27.7739 9.75481 27.7739 9.09944C27.7739 8.44408 27.2426 7.91277 26.5872 7.91277H25.0891V10.2881ZM25.0891 10.2881V13.0669H26.8488C27.6155 13.0669 28.237 12.4424 28.237 11.6757C28.237 10.9091 27.6155 10.2881 26.8488 10.2881H25.0891ZM18.1087 5.48132V30.8732M10.3786 18.3213H4.72695C4.23379 18.3213 3.83398 17.9215 3.83398 17.4283C3.83398 16.9351 4.23379 16.5353 4.72695 16.5353H10.3083M12.8982 16.5353H14.3816C14.8747 16.5353 15.2745 16.9351 15.2745 17.4282C15.2745 17.9214 14.8747 18.3212 14.3816 18.3212H12.8982M6.18323 23.1411H4.72695C4.23379 23.1411 3.83398 22.7413 3.83398 22.2482C3.83398 21.755 4.23379 21.3552 4.72695 21.3552H6.24182M8.81999 21.3551H14.3816C14.8747 21.3551 15.2745 21.755 15.2745 22.2481C15.2745 22.7413 14.8747 23.1411 14.3816 23.1411H8.81999M10.3433 26.1751H8.69365M6.28395 26.1751H4.72729C4.48082 26.1751 4.25706 26.2749 4.09595 26.4367C3.93416 26.5985 3.83433 26.8216 3.83433 27.0681C3.83433 27.561 4.23365 27.961 4.72729 27.961H10.3784M12.863 26.175H14.3816C14.8747 26.175 15.2745 26.5748 15.2745 27.068C15.2745 27.5611 14.8747 27.9609 14.3816 27.9609H12.863",
    stroke: "url(#paint1_linear_173_3195)",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6201 18.8735C12.4184 18.8735 13.0655 18.2264 13.0655 17.4282C13.0655 16.63 12.4184 15.9829 11.6201 15.9829C10.8219 15.9829 10.1748 16.63 10.1748 17.4282C10.1748 18.2264 10.8219 18.8735 11.6201 18.8735Z",
    stroke: "url(#paint2_linear_173_3195)",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.48879 23.6935C8.28703 23.6935 8.93413 23.0464 8.93413 22.2481C8.93413 21.4499 8.28703 20.8028 7.48879 20.8028C6.69056 20.8028 6.04346 21.4499 6.04346 22.2481C6.04346 23.0464 6.69056 23.6935 7.48879 23.6935Z",
    stroke: "url(#paint3_linear_173_3195)",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6201 28.5134C12.4184 28.5134 13.0655 27.8663 13.0655 27.068C13.0655 26.2698 12.4184 25.6227 11.6201 25.6227C10.8219 25.6227 10.1748 26.2698 10.1748 27.068C10.1748 27.8663 10.8219 28.5134 11.6201 28.5134Z",
    stroke: "url(#paint4_linear_173_3195)",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8594 26.175H31.4906C31.9837 26.175 32.3835 26.5748 32.3835 27.068C32.3835 27.5611 31.9837 27.9609 31.4906 27.9609H25.8594M23.3985 27.961H21.8361C21.3429 27.961 20.9431 27.5612 20.9431 27.0681C20.9431 26.5749 21.3429 26.1751 21.8361 26.1751H23.3985M29.9903 21.3551H31.4906C31.9837 21.3551 32.3835 21.755 32.3835 22.2481C32.3835 22.7413 31.9837 23.1411 31.4906 23.1411H29.9903M27.4591 23.1411H21.8361C21.3429 23.1411 20.9431 22.7413 20.9431 22.2482C20.9431 21.755 21.3429 21.3552 21.8361 21.3552H27.4943M23.3985 18.3213H21.8361C21.3429 18.3213 20.9431 17.9215 20.9431 17.4283C20.9431 16.9352 21.3429 16.5353 21.8361 16.5353H23.3282M25.8594 16.5353H31.4906C31.9837 16.5353 32.3835 16.9351 32.3835 17.4282C32.3835 17.9214 31.9837 18.3212 31.4906 18.3212H25.918",
    stroke: "url(#paint5_linear_173_3195)",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5977 28.5134C25.3959 28.5134 26.043 27.8663 26.043 27.068C26.043 26.2698 25.3959 25.6227 24.5977 25.6227C23.7994 25.6227 23.1523 26.2698 23.1523 27.068C23.1523 27.8663 23.7994 28.5134 24.5977 28.5134Z",
    stroke: "url(#paint6_linear_173_3195)",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7288 23.6935C29.527 23.6935 30.1741 23.0464 30.1741 22.2481C30.1741 21.4499 29.527 20.8028 28.7288 20.8028C27.9305 20.8028 27.2834 21.4499 27.2834 22.2481C27.2834 23.0464 27.9305 23.6935 28.7288 23.6935Z",
    stroke: "url(#paint7_linear_173_3195)",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5977 18.8735C25.3959 18.8735 26.043 18.2264 26.043 17.4282C26.043 16.63 25.3959 15.9829 24.5977 15.9829C23.7994 15.9829 23.1523 16.63 23.1523 17.4282C23.1523 18.2264 23.7994 18.8735 24.5977 18.8735Z",
    stroke: "url(#paint8_linear_173_3195)",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_173_3195",
    x1: 18.1088,
    y1: 1,
    x2: 18.1088,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_173_3195",
    x1: 16.0355,
    y1: 5.48132,
    x2: 16.0355,
    y2: 30.8732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_173_3195",
    x1: 11.6201,
    y1: 15.9829,
    x2: 11.6201,
    y2: 18.8735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_173_3195",
    x1: 7.48879,
    y1: 20.8028,
    x2: 7.48879,
    y2: 23.6935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_173_3195",
    x1: 11.6201,
    y1: 25.6227,
    x2: 11.6201,
    y2: 28.5134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_173_3195",
    x1: 26.6633,
    y1: 16.5353,
    x2: 26.6633,
    y2: 27.961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_173_3195",
    x1: 24.5977,
    y1: 25.6227,
    x2: 24.5977,
    y2: 28.5134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_173_3195",
    x1: 28.7288,
    y1: 20.8028,
    x2: 28.7288,
    y2: 23.6935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_173_3195",
    x1: 24.5977,
    y1: 15.9829,
    x2: 24.5977,
    y2: 18.8735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightbid);
export default __webpack_public_path__ + "static/media/Rightbid.ac2393937f93bb9216b9d03e593b1a72.svg";
export { ForwardRef as ReactComponent };